import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-albums-sharp",
  "use": "icon-albums-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-albums-sharp\"><title>Albums</title><path d=\"M128 64h256v32H128zM96 112h320v32H96zM464 448H48V160h416z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol